import React from 'react';
import Logo from '../../../assets/images/register-logo.svg';
import Edges from './Edges';
import PdfViewer from '../../PdfViewer';
import { MY_SELLER_BUCKET_PRE_URL } from '../../../utils/apiConstants';
import { useOpenClose } from '../../../utils/hooks/OpenCloseHook';

const LeftSection: React.FC = () => {
  const [link, setLink] = React.useState('');
  const pdfOpen = useOpenClose(() => setLink(''), setLink); 
  return (
    <>
      <div className="logo">
        <img src={Logo} alt="WaveXChange Logo" />
      </div>
      <div className="description">
        <div className="heading">
          <h2>Host a Private WaveXchange Node</h2>
        </div>
        <Edges pdfOpen={pdfOpen}/>
      </div>
      {link && <PdfViewer showDownload hideAcceptTOC open={pdfOpen.isOpen} onClose={() => pdfOpen.close()} url={`${MY_SELLER_BUCKET_PRE_URL}${link}`} />}
    </>
  );
};

export default LeftSection;
